var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.69302 0.499954C9.92734 0.734269 9.92734 1.11417 9.69302 1.34848L1.15561 9.88589C0.921296 10.1202 0.541398 10.1202 0.307083 9.88589C0.0727691 9.65157 0.0727691 9.27168 0.307083 9.03736L8.84449 0.499954C9.07881 0.26564 9.45871 0.26564 9.69302 0.499954Z",
    fill: "#4D4D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.307083 0.499954C0.541398 0.26564 0.921296 0.26564 1.15561 0.499954L9.69302 9.03736C9.92734 9.27168 9.92734 9.65157 9.69302 9.88589C9.45871 10.1202 9.07881 10.1202 8.84449 9.88589L0.307083 1.34848C0.0727691 1.11417 0.0727691 0.734269 0.307083 0.499954Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.bccc8f0bdf09622eda4ac9c1121397b7.svg";
export { ForwardRef as ReactComponent };